import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';
import {connect} from 'react-redux';
import Address from '../../../../../classes/Address';
import Translation from '../../../../../v2/lang/Translation';
import {getSettings} from '../../../../../v2/selectors/selectors';

const useStyles = createUseStyles({
  storedCardLabelledContents: {
    marginTop: 13,
  },
});

export function StoredCardLabelledContents(props) {
  const classes = useStyles();
  const expiryDateDisplayString = `${props.expiryMonth}/${props.expiryYear}`;
  
  return (
    <div className={classes.storedCardLabelledContents} data-test="StoredCardContents" data-cs-mask>
      <div data-test="StoredCardDetails__name">
        <Translation placeholderValues={[props.nameOnCard]}>
          checkout.payment.method.saved.card.name.on.card.text
        </Translation>
      </div>
      <div data-test="StoredCardDetails__expiry">
        <Translation placeholderValues={[expiryDateDisplayString]}>
          checkout.payment.method.saved.card.expires.text
        </Translation>
      </div>
      {props.address && (
        <div data-test="StoredCardDetails__billingAddress">
          <Translation placeholderValues={[props.address]}>
            checkout.payment.method.saved.card.address.text
          </Translation>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state, ownProps) => {
  const paymentOption = state.payment.options[ownProps.paymentOptionIndex];
  const address = (paymentOption.billingAddress && getSettings(state)?.show_billing_address_in_card)
    ? new Address(paymentOption.billingAddress)?.getAddressString()
    : '';
  
  return {
    expiryMonth: paymentOption.expiryMonth,
    expiryYear: paymentOption.expiryYear,
    nameOnCard: paymentOption.nameOnCard,
    address,
  };
};

StoredCardLabelledContents.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  paymentOptionIndex: PropTypes.number.isRequired,
  expiryMonth: PropTypes.string.isRequired,
  expiryYear: PropTypes.string.isRequired,
  nameOnCard: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
};

export default connect(
  mapStateToProps,
)(StoredCardLabelledContents);
